import { apiService, fetchingAPI } from '@/api'
import { toast } from '@/components/toasts/toast.helpers'

export const useDocsHub = () => {
  const openDocsHub = async () => {
    const errorMessage = 'Failed to load Docs Hub, please reach out to support@balto.ai'
    try {
      const response = await fetchingAPI(`${apiService.auth}/docshub/link`, 'GET', () => {})
      if (response) {
        window.open(response, '_blank')
      } else {
        toast.error(errorMessage)
      }
    } catch {
      toast.error(errorMessage)
    }
  }

  return { openDocsHub }
}
